type TComplianceFilter = {
  complianceRequirementId?: string;
  complianceRequirementItemId?: string;
};

export const foldersQueryKeys = {
  all: ['folders'] as const,
  appVersion: (integrationId: string, versionId: string, compliance: TComplianceFilter = {}) =>
    [
      ...foldersQueryKeys.all,
      'appVersion',
      integrationId,
      versionId,
      compliance.complianceRequirementId ?? null,
      compliance.complianceRequirementItemId ?? null,
    ] as const,
  singleScan: (jobId: string, compliance: TComplianceFilter = {}) =>
    [
      ...foldersQueryKeys.all,
      'singleScan',
      jobId,
      compliance.complianceRequirementId ?? null,
      compliance.complianceRequirementItemId ?? null,
    ] as const,
};
